import { useAnalyzeDiscoveryPrompt, type DiscoverySession, type FilterConditions } from '@/entities/discovery';
import { trackEvent } from '@/shared/track';
import {
  buildAssistantLoadingMessage,
  buildUserPromptMessage,
} from '../ui/discovery-message/build-message.helpers';
import { useDiscoveryMessagesActions } from '../stores/discovery-message-store';
import { useDiscoveryStore } from '../stores/discovery-store';

export type DiscoveryPromptSource = 'free_text' | 'template' | 'find_creators';

export function useDiscoveryPromptSubmit() {
  const { setViewState, setPrompt } = useDiscoveryStore();
  const { appendMessages, replaceMessages } = useDiscoveryMessagesActions();
  const submitMutation = useAnalyzeDiscoveryPrompt();

  const submitPrompt = async (
    session: DiscoverySession,
    prompt: string,
    filters: FilterConditions,
    source: DiscoveryPromptSource = 'free_text',
  ) => {
    setPrompt('');
    trackEvent('Creator', 'submit_prompt', {
      prompt,
      source,
    });
    setViewState('chat');
    appendMessages([
      buildAssistantLoadingMessage(session.session_id),
      buildUserPromptMessage(session.session_id, prompt, filters),
    ]);
    const res = await submitMutation.mutateAsync({
      discoverySessionId: session.session_id,
      request: {
        message: prompt,
        filter_conditions: filters,
      },
    });
    replaceMessages([res.assistant_message, res.user_message]);
  };

  return { submitPrompt };
}
